<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header clearfix">
                    <h3 class="page-title">{{ $t('words.basic_info') }}<span class="page-header-breadcrumb">></span>{{ $t('words.login_account') }}</h3>
                </div>
                <ul class="nav nav-tab nav--tab" id="childTab" role="tablist">
                    <li class="nav-item">
                        <router-link class="nav-link" id="contract-nav" :to="{ name: 'cms-preferences-general' }" aria-controls="general" aria-selected="false">{{ $t('words.contract_info') }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link  class="nav-link" id="service_account-nav" :to="{ name: 'cms-preferences-service_account' }" aria-controls="service_account" aria-selected="false">{{ $t('words.service_account')}}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link  class="nav-link active" id="login_account-nav" :to="{ name: 'cms-preferences-login_account' }" aria-controls="login_account" aria-selected="false">{{ $t('words.login_account') }}</router-link>
                    </li>
                </ul>
            </div>
            <div class="module">
                <div class="module-header-tab">
                    <ul class="nav nav-tab" id="childTabSub" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="info-nav" data-toggle="tab" href="#info-tab" role="tab" aria-controls="info" aria-selected="true">{{ $t('words.login_info') }}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="password-nav" data-toggle="tab" href="#password-tab" role="tab" aria-controls="password" aria-selected="false">{{ $t('words.password_change') }}</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div class="tab-pane active" id="info-tab" role="tabpanel" aria-labelledby="info-tab">
                        <tab-info></tab-info>
                    </div>
                    <div class="tab-pane mt-2" id="password-tab" role="tabpanel" aria-labelledby="password-tab">
                        <tab-password></tab-password>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import TabInfo from './user/TabInfo';
import TabPassword from './user/TabPassword';

export default {
    components: {
        TabInfo,
        TabPassword,
    },
    mounted() {
    },
    computed: {
        ...mapGetters([
            'getMenuToggle',
        ]),
    },
};
</script>

<style scoped>

</style>
